import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export function StatCard({ label, value, icon: Icon, hint, loading, accent }: { label: string; value: ReactNode; icon?: LucideIcon; hint?: ReactNode; loading?: boolean; accent?: string }) {
  return (
    <Card className="gap-0 py-0">
      <CardContent className="space-y-2 p-5">
        <div className="flex items-center justify-between">
          <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">{label}</p>
          {Icon && <span className={cn('grid size-8 place-items-center rounded-md bg-muted text-muted-foreground', accent)}><Icon className="size-4" /></span>}
        </div>
        {loading ? <Skeleton className="h-8 w-20" /> : <div className="text-2xl font-semibold tabular-nums">{value}</div>}
        {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      </CardContent>
    </Card>
  );
}
